const getAccessingDevice = (): 'sp' | 'pc' => {
  if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android|Mobile)/i)) {
    return 'sp';
  } else {
    return 'pc';
  }
};

export default getAccessingDevice;
